export const colors = {
  primary: "#ff4f50",
};
